import React from 'react'
import styled from 'styled-components'

const OverlayContainer = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  z-index: 1000;
  transition: opacity 0.3s ease-in-out;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
`

interface OverlayProps {
  isOpen: boolean
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
}

const Overlay: React.FC<OverlayProps> = ({ isOpen, onClick }) => {
  return <OverlayContainer isOpen={isOpen} onClick={onClick} />
}

export default Overlay
